import { ShipmentInfoReturnRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';

class ShipmentInfoReturnService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new ShipmentInfoReturnRouteService());
	}

	find = filter => {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	};

	reprintLabel = (shipmentInfoReturnId, getLabel) => {
		var url = this.routeService.reprintLabel(shipmentInfoReturnId, getLabel);
		return this.apiClient.put(url, shipmentInfoReturnId);
	};

	createReturnLabel = returnLabelParams => {
		var url = this.routeService.createReturnLabel(returnLabelParams);
		return this.apiClient.post(url, returnLabelParams);
	};
}

export default ShipmentInfoReturnService;



// WEBPACK FOOTER //
// ./src/common/data/services/ShipmentInfoReturnService.js